// extracted by mini-css-extract-plugin
export default {"mainItem":"TermsAndConditions_mainItem__jbv3T"};